module.exports = __webpack_public_path__ + "static/img/wechat.d018b3db.png";